<script>
export default {
  props: {
    percentageComplete: {
      type: Number,
      required: true,
    },
  },
  computed: {
    getProgressBarColorClass() {
      // Customize the color ranges based on your requirements
      if (this.percentageComplete < 50) {
        return 'orange' // Change to the desired class for the lower range
      } else if (this.percentageComplete < 80) {
        return 'green' // Change to the desired class for the mid range
      } else {
        return 'blue' // Change to the desired class for the higher range
      }
    },
  },
}
</script>

<template>
  <div class="graph">
    <div class="progress-line">{{ percentageComplete }}%</div>

    <v-progress-linear
      :color="getProgressBarColorClass"
      :value="percentageComplete"
    ></v-progress-linear>
  </div>
</template>

<style scoped>
.graph {
  /* Add your styling for the graph container here */
}

.progress-line {
  /* Add your styling for the progress line here */
}

/* Define styles for different color classes */
.blue {
  background-color: blue;
}

.green {
  background-color: green;
}

.pink {
  background-color: pink;
}
</style>
